import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function AdminLoginPage() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            const { data } = await api.post("/auth/login", { email, password });
            localStorage.setItem("cbc_admin_token", data.token);
            toast.success("Welcome back, Erin.");
            navigate("/admin");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Login failed.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div
            data-testid="admin-login-page"
            className="min-h-screen bg-sand-100 flex items-center justify-center px-6"
        >
            <div className="w-full max-w-md bg-white border border-palm-400/30 rounded-sm p-10">
                <Link
                    to="/"
                    className="overline text-forest-400 hover:text-forest-700 transition-colors"
                >
                    ← Coral Bay Catering
                </Link>
                <h1 className="font-serif text-4xl text-forest-700 mt-4">Admin sign in</h1>
                <p className="text-forest-700/60 text-sm mt-2">
                    Manage bookings, calendar, and inquiries.
                </p>
                <form onSubmit={submit} className="mt-8 space-y-5" data-testid="login-form">
                    <div>
                        <Label htmlFor="email" className="text-xs tracking-[0.18em] uppercase text-forest-400">
                            Email
                        </Label>
                        <Input
                            id="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            data-testid="login-email"
                            className="mt-2 border-palm-400/50 focus-visible:ring-forest-700"
                        />
                    </div>
                    <div>
                        <Label
                            htmlFor="password"
                            className="text-xs tracking-[0.18em] uppercase text-forest-400"
                        >
                            Password
                        </Label>
                        <Input
                            id="password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            data-testid="login-password"
                            className="mt-2 border-palm-400/50 focus-visible:ring-forest-700"
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={submitting}
                        data-testid="login-submit-btn"
                        className="w-full bg-forest-700 text-sand-100 px-6 py-3.5 rounded-sm hover:bg-forest-900 transition-colors text-sm tracking-wide disabled:opacity-50"
                    >
                        {submitting ? "Signing in…" : "Sign in"}
                    </button>
                </form>
            </div>
        </div>
    );
}
